import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { IconComponent } from '@sarasanalytics-com/design-system';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-desktop-view-restricted',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './desktop-view-restricted.component.html',
  styleUrls: ['./desktop-view-restricted.component.scss']
})
export class DesktopViewRestrictedComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  isMobile = false;
  showComponent = true;
  private mediaQuery!: MediaQueryList;
  private mediaQueryListener!: (event: MediaQueryListEvent) => void;
  private readonly AUTH_ROUTES = ['/auth', '/login', '/forgot-password', '/verify', '/reset-password'];
  private isAuthRoute = false;

  ngOnInit() {
    this.checkIfAuthRoute(this.router.url);
    this.setupMobileDetection();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkIfAuthRoute(event.url);
    });
  }

  private checkIfAuthRoute(url: string) {
    this.isAuthRoute = this.AUTH_ROUTES.some(route => url.includes(route));
    this.updateComponentVisibility();
  }

  private setupMobileDetection() {
    this.mediaQuery = window.matchMedia('(max-width: 1000px)');
    this.isMobile = this.mediaQuery.matches;

    this.mediaQueryListener = (event: MediaQueryListEvent) => {
      this.isMobile = event.matches;
      this.updateComponentVisibility();
    };

    this.mediaQuery.addEventListener('change', this.mediaQueryListener);
    this.updateComponentVisibility();
  }

  private updateComponentVisibility() {
    const isMobileViewAccepted = sessionStorage.getItem('mobileViewAccepted');
    this.showComponent = this.isMobile && !this.isAuthRoute && !isMobileViewAccepted;
  }

  ngOnDestroy() {
    if (this.mediaQuery && this.mediaQueryListener) {
      this.mediaQuery.removeEventListener('change', this.mediaQueryListener);
    }
  }

  closePopup() {
    const productUrl = window.location.hostname === 'localhost' ? 'http://localhost:4200/' : environment.PRODUCTS['SARAS'];
    window.location.href = productUrl;
  }

  continueOnMobile() {
    sessionStorage.setItem('mobileViewAccepted', 'true');
    this.showComponent = false;
  }
}
